const INITIAL_VALUES = {
  username: '',
  password: '',
};

export default INITIAL_VALUES;
